import { Store } from 'src/store/index';

const getIsAgreeWithLowDPI = (store: Store) => store.design.isAgreeWithLowDPI;

export default getIsAgreeWithLowDPI;
